import {setFirebaseToken} from "../../actions/account";
import {PLAIN_API} from "../HttpHandler";
import {store} from "../../index";
import config from "../../../config";

const BACKEND_URL = `${process.env.BACKEND_URL}`;
const getToken = (params) => {
  PLAIN_API.defaults.headers.Authorization = "Bearer " + process.env.API_KEY;
  return PLAIN_API.get(
    BACKEND_URL + `/api/v1/turnero/bookings/${params.tokenUUID}`
  ).then((res) => {
    return res;
  });
};
const getFirebaseToken = () => {
  PLAIN_API.defaults.headers.Authorization = "Bearer " + process.env.API_KEY;
  return PLAIN_API.get(
    // BACKEND_URL + `/api/v1/turnero/firebasetoken`
    config.endPoints.firebasetokens
  ).then((res) => {
    if (res.token) {
      store.dispatch(setFirebaseToken(res.token));
    }
    return res;
  });
};
export {getToken, getFirebaseToken};
